/**
 * Classe do equipamento: decide em que aba da tela de Equipamentos ele aparece.
 *
 * Vem do grupo do tipo configurado em Configurações (abas do relatório de manutenção,
 * grupo_tipo_equipamento): validadores → Validador; rastreadores e validador/rastreador/bilhetagem
 * (AVL que também valida) → Rastreador; DVR e tipo sem grupo → Outro. O FaceID é sempre
 * Validador: as funções de suite só existem nessa aba.
 */

// Mesmo tipo fixo da API e do monitor (FACEID_TIPO_EQUIPAMENTO): só o FaceID fala suite.
export const TIPO_FACEID = 6;

export const CLASSE_RASTREADOR = 'RASTREADOR';
export const CLASSE_VALIDADOR = 'VALIDADOR';
export const CLASSE_OUTRO = 'OUTRO';
export const CLASSES = [CLASSE_RASTREADOR, CLASSE_VALIDADOR, CLASSE_OUTRO];

export const ICONE_CLASSE = {
  [CLASSE_RASTREADOR]: 'mdi-crosshairs-gps',
  [CLASSE_VALIDADOR]: 'mdi-face-recognition',
  [CLASSE_OUTRO]: 'mdi-devices',
};

const CLASSE_DO_GRUPO = {
  validadores: CLASSE_VALIDADOR,
  rastreadores: CLASSE_RASTREADOR,
  validadores_rastreadores_bilhetagem: CLASSE_RASTREADOR,
};

// Aceita equipamento ou tipo de equipamento (ambos trazem id_tipo_equipamento e o grupo).
export function classeDoEquipamento(item) {
  if (!item) return CLASSE_OUTRO;
  if (item.id_tipo_equipamento == TIPO_FACEID) return CLASSE_VALIDADOR;
  return CLASSE_DO_GRUPO[item.grupo_tipo_equipamento] || CLASSE_OUTRO;
}

// Leitor que fala com alguma suite (ISAPI / HikCentral): o único com status de envio,
// inventário e ações de sincronização. Inativo não entra na rotina.
export function falaComSuite(item) {
  return !!item && item.id_tipo_equipamento == TIPO_FACEID && item.ativo == 1 && !!item.suite_efetiva;
}
